import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';

import { Etapes, LevelToEtape, RenderSelected } from '../settings';
import { useEffect } from 'react';




const ColorlibConnector = withStyles({
    alternativeLabel: {
    },
    active: {
        '& $line': {
            backgroundImage:
                'linear-gradient( 95deg,#ffdd00 0%,#ffdd00 50%,#097b39 100%)',
        },
    },
    completed: {
        '& $line': {
            backgroundImage:
                'linear-gradient( 95deg,#ffdd00 0%,#ffdd00 50%,#097b39 100%)',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);



const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

function getSteps() {
    return Etapes;
}


export default function SweetStepper({ state, StepClickCallBack }) {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleClick = (i) => {
        StepClickCallBack(i)
    };

    useEffect(() => {
        var _li = Etapes.map(x => x.number).indexOf(LevelToEtape[state.level].number)

        setActiveStep(_li === -1 ? 0 : _li)
    })

    return (
        <div className={classes.root}>
            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                {steps.map((s, i) => (
                    <Step key={`stk${s.number}${i}`}>
                        <StepLabel onClick={() => handleClick(s.number)}>
                            {s.Deschtml}
                            {RenderSelected(s.number,state)}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </div>
    );
}
